'use client';

import {
  TheFooter as BaseTheFooter,
  TheFooterProps,
} from '@hyphengroup/cms-components';
import { pushDataLayer } from '$/components/cms/pushDataLayer';

export function TheFooter(props: Omit<TheFooterProps, 'pushDataLayer'>) {
  return <BaseTheFooter {...props} pushDataLayer={pushDataLayer} />;
}
